import { defineMessages } from 'react-intl';

export default defineMessages({
	widgetErrorTitle: {
		id: 'rovo.service-agent.widget.error-boundary.title.non-final',
		defaultMessage: 'Rovo Service Agent widget unavailable',
		description: 'Title for the error flag for when the widget failed to load',
	},
	widgetErrorDescription: {
		id: 'rovo.service-agent.widget.error-boundary.description.non-final',
		defaultMessage: 'The Rovo Service Agent failed to load. Please refresh the page to try again.',
		description: 'Description for the error flag for when the widget failed to load',
	},
});
